// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/detailed-product-card/detailed-product-card.component.scss
// module id = 262
// module chunks = 0